$(document).ready(function () {
  let p = $('body').attr('p');
  let posType = $('body').attr('pos_type');

  if (p == 'events' && posType == 'classic') {
    const $container = $('#classic-category-product-container');
    const isEnableCategorySwip =
      $container.attr('data-enable-category-swip') == 1;
    console.log(isEnableCategorySwip);

    if (isEnableCategorySwip) {
      let touchStartX = 0;
      let touchStartY = 0;
      let isScrolling = false; // Flag to detect if user is scrolling vertically
      const swipeThreshold = 70; // Slightly higher threshold for better accuracy

      $container.on('touchstart', function (e) {
        touchStartX = e.originalEvent.touches[0].clientX;
        touchStartY = e.originalEvent.touches[0].clientY;
        isScrolling = false; // Reset on every new touch
      });

      $container.on('touchmove', function (e) {
        let touchMoveX = e.originalEvent.touches[0].clientX;
        let touchMoveY = e.originalEvent.touches[0].clientY;

        let diffX = Math.abs(touchMoveX - touchStartX);
        let diffY = Math.abs(touchMoveY - touchStartY);

        // If vertical movement is greater than horizontal, it's a scroll.
        // We set isScrolling to true to block the swipe logic later.
        if (diffY > diffX && diffY > 10) {
          isScrolling = true;
        }
      });

      $container.on('touchend', function (e) {
        // If the movement was identified as a vertical scroll, STOP HERE.
        if (isScrolling) return;

        let touchEndX = e.originalEvent.changedTouches[0].clientX;
        let diffX = touchStartX - touchEndX;

        // Small movement check
        if (Math.abs(diffX) < swipeThreshold) return;

        const $activeTab = $('.classic-category-nav-link').filter('.active');
        if (!$activeTab.length) return;

        const currentIndex = $('.classic-category-nav-link').index($activeTab);

        if (diffX > 0) {
          // Swipe Left -> Next
          if (currentIndex < $('.classic-category-nav-link').length - 1) {
            const $nextTab = $('.classic-category-nav-link').eq(
              currentIndex + 1
            );
            triggerTab($nextTab);
          }
        } else {
          // Swipe Right -> Prev
          if (currentIndex > 0) {
            const $prevTab = $('.classic-category-nav-link').eq(
              currentIndex - 1
            );
            triggerTab($prevTab);
          }
        }
      });

      function triggerTab($tab) {
        const $allTabs = $('.classic-category-nav-link');

        $(document.activeElement).trigger('blur');
        $allTabs.removeClass('active');

        $tab.trigger('click');

        $tab.addClass('active');
        if ($tab[0]) {
          $tab[0].scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      }
    }
  }
});
